import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import ptBR from "date-fns/locale/pt-BR";
import en from "date-fns/locale/en-US";
import { IconLabelSwitch } from '../../iconSwitch/IconLabelSwitch';
import "./CustomDatePickerStyle.scss"

const CustomDatePicker = ({
    id,
    name,
    selectedDate,
    handleChange,
    error,
    disablePast,
    disableFuture,
    translationString,
    disabled,
}) => {
    const { t, i18n } = useTranslation();
    const [invalidDate, setInvalidDate] = useState(false);

    const getLocale = () => {
        switch (i18n.language) {
            case "en":
                return en;
            case "ptBR":
                return ptBR;
            default:
                break;
        }
    };

    const locale = getLocale();

    //Valida a Data
    useEffect(() => {
        if (selectedDate) {
            if (selectedDate.toString() === 'Invalid Date') {
                setInvalidDate(true);
            } else if (disablePast) {
                setInvalidDate(
                    selectedDate < new Date(new Date().setHours(0, 0, 0, 0))
                );
            } else if (disableFuture) {
                setInvalidDate(
                    selectedDate > new Date(new Date().setHours(23, 59, 59, 59))
                );
            } else {
                setInvalidDate(false)
            }
        } else {
            setInvalidDate(false)
        }
    }, [selectedDate]);

    return (
        <div>
            <div>
                <IconLabelSwitch
                    name='date'
                    labelName={translationString ? t(translationString) : t(name)}
                    fontSize="small"
                />
            </div>
            <div>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                    <KeyboardDatePicker
                        className="defaultDatePicker"
                        autoOk={true}
                        disableToolbar
                        variant="inline"
                        fullWidth
                        inputVariant="outlined"
                        format="dd/MM/yyyy"
                        id={id}
                        label={selectedDate ? "" : t("pickADate")}
                        value={selectedDate}
                        onChange={date => handleChange({ "target": { "value": date, "name": name } })}
                        KeyboardButtonProps={{
                            "aria-label": "change date",
                        }}
                        invalidDateMessage=""
                        error={error || invalidDate}
                        disablePast={disablePast ? true : false}
                        disableFuture={disableFuture ? true : false}
                        minDateMessage=""
                        maxDateMessage=""
                        size={process.env.REACT_APP_TEXT_FIELD_SIZE}
                        disabled={disabled}
                    />
                </MuiPickersUtilsProvider>
            </div>
        </div>
    );
};

export default CustomDatePicker;


//Exemplos : 

//selectedDate = Value

//disableFuture || disablePast não é Obrigatorio

{/* 
                <CustomDatePicker
                  id="startDatePicker"
                  name="startDate"
                  selectedDate={startDate}
                  handleChange={handleChange}
                  disableFuture={true}
                  error={
                    endDate !== null &&
                    startDate > endDate
                  }
                /> 
            */}
